import React from "react";
import { Col, Container, Row, Form } from "react-bootstrap";
import { useWorkOrders } from "../../../data/WorkOrdersHook";
import "./WorkItemEntry.css";

function DisconnectionEntry() {
  const workOrdersRepository = useWorkOrders();

  const updateJobSpecificAccessNotes = (e) => {
    const current = workOrdersRepository.getEntry();
    const revised = { ...current, jobSpecificAccessNotes: e.target.value };
    workOrdersRepository.setEntry(revised);
  };

  const handleSuppliesToDisconnectChange = (e) => {
    const current = workOrdersRepository.getEntry();
    const revised = { ...current, [e.target.id]: !current[e.target.id] };
    workOrdersRepository.setEntry(revised);
  };

  const workOrder = workOrdersRepository.getEntry();

  return (
    <div className="work-order-item-section">
      <h3>Disconnection Work Item Details</h3>
      <Container className="work-order-item-container">
        <Row>
          <Col>
            <Form.Group className="mb-3" controlId="suppliesToDisconnect">
              <Form.Label>Supplies To Disconnect</Form.Label>
              <Form.Check
                type="checkbox"
                id="disconnectelectricity"
                label="Disconnect Electricity"
                checked={workOrder.disconnectelectricity}
                onChange={handleSuppliesToDisconnectChange}
              />
              <Form.Check
                type="checkbox"
                id="disconnectheat"
                label="Disconnect Heat"
                checked={workOrder.disconnectheat}
                onChange={handleSuppliesToDisconnectChange}
              />
              <Form.Check
                type="checkbox"
                id="disconnecthotwater"
                label="Disconnect Hot Water"
                checked={workOrder.disconnecthotwater}
                onChange={handleSuppliesToDisconnectChange}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="jobSpecificAccessNoteGroup">
              <Form.Label>Job Specific Access Notes</Form.Label>
              <Form.Control
                as="input"
                value={workOrder.jobSpecificAccessNotes}
                onChange={updateJobSpecificAccessNotes}
              />
            </Form.Group>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default DisconnectionEntry;
